"use client";
import React from "react";
import clsx from "clsx";

interface ButtonProps {
    text: any;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    type?: "button" | "submit" | "reset";
    disabled?: boolean;
    ariaLabel?: string;
    className?: string;
    buttonType?: keyof typeof ButtonType;
}

export const ButtonType: Record<string, string> = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    GREENBG: 'greenbg',
    GREENFG: 'greenfg',
    BTN_ONE: 'btnone'
}

const variantStyles = {
    [ButtonType.PRIMARY]: "!bg-orange-500 !text-white !border-orange-500",
    [ButtonType.SECONDARY]: "!bg-white !text-orange-500 !border-orange-500",
    [ButtonType.GREENBG]: "!bg-[#0D908E] !text-white !border-[#0D908E]",
    [ButtonType.GREENFG]: "!bg-white !text-[#0D908E] !border-[#0D908E]",
    [ButtonType.BTN_ONE]: "text-[16px] text-[#0D908E] leading-none cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed !border-0 !p-0"
}

const Button: React.FC<ButtonProps> = ({
    text,
    onClick,
    type = "button",
    disabled = false,
    ariaLabel,
    className,
    buttonType = ButtonType.PRIMARY,
}) => {
    return (
        <button
            type={type}
            aria-label={ariaLabel || text}
            onClick={onClick}
            disabled={disabled}
            className={clsx(
                "border-2 px-4 py-2 rounded-full text-md md:text-lg font-semibold cursor-pointer bg-white transition-transform duration-200 hover:scale-105",
                "disabled:opacity-50 disabled:cursor-not-allowed",
                variantStyles[buttonType],
                className
            )}
        >
            {text}
        </button>
    );
};

export default React.memo(Button);
